import * as React from 'react';
import { SVGProps, memo } from 'react';

/**
 * НЕ РЕДАКТИРОВАТЬ
 *
 * Этот файл создан автоматически с помощью svgr
 *
 * Подробнее, как работать с иконками:
 * @see https://lvtv.me/icons
 */
const SvgQuestionTip = (props: SVGProps<SVGSVGElement>) => (
  <svg
    viewBox="0 0 16 16"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <circle cx={8} cy={8.682} r={6.5} stroke="#919499" />
    <path
      d="M5.8 6C6.3 5.5 7 5 8 5c1 0 1.9.634 1.9 1.5 0 .62-.4 1.2-1.6 2-1.2.8-.5 1.5-.5 1.5l.4.409"
      stroke="#919499"
    />
    <circle
      cx={8}
      cy={12}
      r={0.5}
      fill="#919499"
      stroke="#919499"
      strokeWidth={0.333}
    />
  </svg>
);
const Memo = memo(SvgQuestionTip);
export default Memo;
